<template>
    <span
        class="demo-locked"
        :class="lockedClass"
        v-tooltip.bottom="tooltipText"
    >
        <slot :locked="locked" />
        <i
            v-if="locked && showBadge"
            class="fa-solid fa-lock demo-locked__icon"
            aria-hidden="true"
        ></i>
    </span>
</template>

<script>
import { useDemoStore } from '@/stores/demoStore'

export default {
    name: 'DemoLocked',
    props: {
        /** Blocked feature key from demoStore; optional when `forced` is used */
        feature: { type: String, default: null },
        /** Force lock+tooltip in demo (display-only fields, no feature key) */
        forced: { type: Boolean, default: false },
        showBadge: { type: Boolean, default: true },
        /** Poly/icon buttons or full-width form controls: lock on corner */
        corner: { type: Boolean, default: false },
        /** i18n key for the feature name (shown in tooltip) */
        label: { type: String, default: null },
    },
    setup() {
        const demo = useDemoStore()

        return { demo }
    },
    computed: {
        locked() {
            if (this.forced) {
                return this.demo.isDemo
            }
            return this.feature ? this.demo.isBlocked(this.feature) : false
        },
        tooltipText() {
            const featureLabel = this.label ? this.$t(this.label) : null
            if (this.locked) {
                const demoMsg = this.$t('Not available in demo mode')
                return featureLabel ? `${featureLabel} - ${demoMsg}` : demoMsg
            }
            return featureLabel
        },
        lockedClass() {
            /**
             * lock-nav — nav (Vehicles / Trimble)
             * lock-corner — poly/icon buttons / form controls
             * is-locked — no badge (mobile menu)
             */
            if (!this.locked) return null
            if (!this.showBadge) return 'is-locked'
            return this.corner ? 'lock-corner' : 'lock-nav'
        },
    },
}
</script>

<style scoped>
.demo-locked {
    display: inline-flex;
    position: relative;
    max-width: 100%;
    align-items: center;
    overflow: visible;
}

.is-locked,
.lock-nav,
.lock-corner {
    cursor: not-allowed;
}

.lock-nav {
    padding-right: 0.35rem;
}

.demo-locked__icon {
    position: absolute;
    font-size: 10px;
    line-height: 1;
    pointer-events: none;
    z-index: 2;
    color: #f59e0b;
}

.lock-nav .demo-locked__icon {
    top: 6px;
    right: 10px;
}

.lock-corner {
    display: block;
    width: 100%;
}

.lock-corner :deep(input),
.lock-corner :deep(.p-inputnumber),
.lock-corner :deep(.p-inputnumber-input),
.lock-corner :deep(.p-select),
.lock-corner :deep(.p-disabled),
.lock-corner :deep(.p-component) {
    cursor: not-allowed !important;
}

.lock-corner .demo-locked__icon {
    top: 4px;
    right: 6px;
}
</style>
